// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { BEBaseElement } from './BEBaseElement';
import { BEConstant } from './BEConstant';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 常量项 实体类
 * 常量的项
 */
export class ConstantItem extends BEBaseElement {
  /** 常量值 : 常量值 */
  private _itemValue: string;

  /** 设置：常量值 */
  public get itemValue() {
    return this._itemValue;
  }

  /** 获取：常量值 */
  public set itemValue(value: string) {
    this._itemValue = value;
  }

  /** 数据类型 : 数据类型 */
  private _dataType: EnumDataType;

  /** 设置：数据类型 */
  public get dataType() {
    return this._dataType;
  }

  /** 获取：数据类型 */
  public set dataType(value: EnumDataType) {
    this._dataType = value;
  }

  /** 常量 的ID */
  private _constant_ID: string;

  /** 获取：常量 的ID */
  public get constant_ID() {
    return this._constant_ID;
  }

  /** 设置：常量 的ID */
  public set constant_ID(value: string) {
    this._constant_ID = value;
  }

  /** 常量  */
  private _constant: BEConstant;

  /** 获取：常量  */
  public get constant() {
    return this._constant;
  }

  /** 设置：常量  */
  public set constant(value: BEConstant) {
    this._constant = value;
    if (value !== null) {
      this.constant_ID = value.id;
    } else {
      this.constant_ID = '';
    }
  }

  constructor() {
    super();
    this._itemValue = '';
    this._dataType = EnumDataType.String;
    this._constant_ID = '';
    this._constant = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ConstantItem, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.itemValue = element.itemValue;
      this.dataType = element.dataType;
      this.constant_ID = element.constant_ID;
      if (hasReference && element.constant !== null) {
        this.constant = element.constant;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.itemValue = json.ItemValue;
    this.dataType = json.DataType as EnumDataType;
    this.constant_ID = json.Constant_ID;
    // if (json.Constant !== null) {
    //   this.constant = BEConstant.Create(json.Constant);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.ItemValue = this.itemValue;
    json.DataType = this.dataType;
    json.Constant_ID = this.constant_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('代码属性', 'itemValue', '常量值', EnumDataType.String, this.itemValue, true, '常量值', '', '');
    context.addRow('代码属性', 'dataType', '数据类型', EnumDataType.Reference, this.dataType, true, '数据类型', 'EnumDataType', 'PGRowEnumValue');
    return context;
  }

  static Create(json: any): ConstantItem {
    const constantItem = new ConstantItem();
    constantItem.Deserialize(json);
    constantItem.json = json;
    return constantItem;
  }
}
